import React from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "../shared/components/AppBar";
import {
  Link as RouterLink,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";
import {
  Drawer,
  IconButton,
  Box,
  Link,
  WithStyles,
  Toolbar,
} from "@material-ui/core";
import { Menu as MenuIcon } from "react-feather";
import { renderNavLinks } from "../navigation/navigationHelpers";

const styles = (theme: any) => ({
  title: {
    fontSize: 24,
  },
  placeholder: {
    height: 64,
    [theme.breakpoints.up("sm")]: {
      height: 70,
    },
  },
  toolbar: {
    justifyContent: "space-between",
    height: 64,
    [theme.breakpoints.up("sm")]: {
      height: 70,
    },
  },
  left: {
    flex: 1,
  },
  flyoutMenuButton: {
    color: theme.palette.common.white,
    marginLeft: -12,
  },
  right: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
  },
  rightLink: {
    fontSize: 16,
    color: theme.palette.common.white,
    marginLeft: theme.spacing(3),
    cursor: "pointer",
  },
  linkSecondary: {
    color: theme.palette.secondary.main,
  },
  flyoutDrawer: {
    width: 256,
  },
});

interface Props extends WithStyles<typeof styles>, RouteComponentProps {}

interface State {
  flyoutNavOpen: boolean;
}

class AppNavBar extends React.Component<Props, State> {
  _unsubscribeHistoryListener: () => void = () => null;

  constructor(props: Props) {
    super(props);
    this.state = {
      flyoutNavOpen: false,
    };
  }

  componentDidMount() {
    this._unsubscribeHistoryListener = this.props.history.listen(
      (location, action) => {
        this.setState({ flyoutNavOpen: false });
      }
    );
  }

  componentWillUnmount() {
    this._unsubscribeHistoryListener();
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <AppBar>
          <Toolbar className={classes.toolbar}>
            <Drawer
              anchor="left"
              classes={{ paper: classes.flyoutDrawer }}
              onClose={() => this.setState({ flyoutNavOpen: false })}
              open={this.state.flyoutNavOpen}
              variant="temporary"
            >
              <Box height="100%" display="flex" flexDirection="column">
                <Box p={2}>{renderNavLinks(window.location.pathname)}</Box>
              </Box>
            </Drawer>
            <div className={classes.left}>
              <IconButton
                className={classes.flyoutMenuButton}
                color="inherit"
                onClick={() => this.setState({ flyoutNavOpen: true })}
              >
                <MenuIcon />
              </IconButton>
            </div>
            <Link
              key="/"
              variant="h6"
              underline="none"
              color="inherit"
              className={classes.title}
              component={RouterLink}
              to="/"
            >
              {"web field guide"}
            </Link>
            <div className={classes.right}></div>
          </Toolbar>
        </AppBar>
        <div className={classes.placeholder} />
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(AppNavBar));
